import { render, staticRenderFns } from "./UsersBotPage.vue?vue&type=template&id=2833e2be&scoped=true&"
import script from "./UsersBotPage.vue?vue&type=script&lang=js&"
export * from "./UsersBotPage.vue?vue&type=script&lang=js&"
import style0 from "./UsersBotPage.vue?vue&type=style&index=0&id=2833e2be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2833e2be",
  null
  
)

export default component.exports